import styled from 'styled-components';

export default styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;

  .rbc-calendar {
    height: 700px;
  }
`;

export const BoxWithIcon = styled.span`
  display: flex;
  align-items: center;
  `;
